/*
 * Photos and videos on the "Write a review" form.
 *
 * The file goes straight from the browser to Vercel Blob (a video is too big
 * for a serverless request). Our backend only hands out a one-file upload
 * token; the link to the uploaded file is then added to the form as a hidden
 * field, so it arrives in the review e-mail like every other answer.
 */
(function () {
  var MAX_FILES = 3;
  var TYPES = {
    'image/jpeg': 'jpg', 'image/png': 'png', 'image/webp': 'webp',
    'image/heic': 'heic', 'image/heif': 'heif',
    'video/mp4': 'mp4', 'video/quicktime': 'mov', 'video/webm': 'webm'
  };
  var BY_EXTENSION = {
    jpg: 'image/jpeg', jpeg: 'image/jpeg', png: 'image/png', webp: 'image/webp',
    heic: 'image/heic', heif: 'image/heif',
    mp4: 'video/mp4', m4v: 'video/mp4', mov: 'video/quicktime', webm: 'video/webm'
  };
  var MB = 1024 * 1024;

  function contentTypeOf(file) {
    var type = (file.type || '').toLowerCase();
    if (TYPES[type]) return type;
    var ext = (file.name.split('.').pop() || '').toLowerCase();
    return BY_EXTENSION[ext] || '';
  }

  function randomId() {
    var bytes = new Uint8Array(16);
    window.crypto.getRandomValues(bytes);
    return Array.prototype.map.call(bytes, function (b) {
      return ('0' + b.toString(16)).slice(-2);
    }).join('');
  }

  function size(bytes) {
    return bytes >= MB ? (bytes / MB).toFixed(1) + ' MB' : Math.max(1, Math.round(bytes / 1024)) + ' KB';
  }

  function init(root) {
    var api = root.getAttribute('data-api');
    var input = root.querySelector('[data-rf-media-input]');
    var list = root.querySelector('[data-rf-media-list]');
    var fields = root.querySelector('[data-rf-media-fields]');
    var form = root.closest('form');
    var submit = form && form.querySelector('[data-rf-submit]');
    var note = root.querySelector('[data-rf-media-note]');
    if (!api || !input || !list || !fields) return;

    var items = [];
    var busy = 0;

    function sync() {
      if (submit) {
        submit.disabled = busy > 0;
        submit.setAttribute('aria-busy', busy > 0 ? 'true' : 'false');
      }
      root.classList.toggle('rf-media--full', items.length >= MAX_FILES);
      input.disabled = items.length >= MAX_FILES;
    }

    function say(text) {
      if (note) {
        note.textContent = text || '';
        note.hidden = !text;
      }
    }

    function put(item, file, type, grant) {
      return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open('PUT', grant.api + '/?pathname=' + encodeURIComponent(item.pathname));
        xhr.setRequestHeader('authorization', 'Bearer ' + grant.token);
        xhr.setRequestHeader('x-api-version', grant.version);
        xhr.setRequestHeader('x-vercel-blob-access', 'private');
        xhr.setRequestHeader('x-content-type', type);
        xhr.upload.onprogress = function (e) {
          if (e.lengthComputable) item.bar.style.width = Math.round((e.loaded / e.total) * 100) + '%';
        };
        xhr.onload = function () {
          if (xhr.status >= 200 && xhr.status < 300) resolve();
          else reject(new Error('Upload failed (' + xhr.status + ').'));
        };
        xhr.onerror = function () { reject(new Error('Upload failed. Check your connection and try again.')); };
        xhr.send(file);
      });
    }

    function remove(item) {
      items = items.filter(function (x) { return x !== item; });
      if (item.li.parentNode) item.li.parentNode.removeChild(item.li);
      if (item.field && item.field.parentNode) item.field.parentNode.removeChild(item.field);
      renumber();
      sync();
    }

    function renumber() {
      items.forEach(function (it, i) {
        if (it.field) it.field.name = 'contact[Photo or video ' + (i + 1) + ']';
      });
    }

    function add(file) {
      var type = contentTypeOf(file);
      if (!type) { say('“' + file.name + '” is not a photo or video we can use. Please choose a JPG, PNG, HEIC, MP4 or MOV file.'); return; }
      var isVideo = type.indexOf('video/') === 0;
      var limit = (isVideo ? 100 : 15) * MB;
      if (file.size > limit) { say('“' + file.name + '” is too large (' + size(file.size) + '). Photos can be up to 15 MB and videos up to 100 MB.'); return; }
      if (items.length >= MAX_FILES) { say('You can add up to ' + MAX_FILES + ' files.'); return; }

      var li = document.createElement('li');
      li.className = 'rf-media__item';
      var name = document.createElement('span');
      name.className = 'rf-media__name';
      name.textContent = file.name + ' · ' + size(file.size);
      var track = document.createElement('span');
      track.className = 'rf-media__track';
      var bar = document.createElement('span');
      bar.className = 'rf-media__bar';
      track.appendChild(bar);
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'rf-media__remove';
      btn.setAttribute('aria-label', 'Remove ' + file.name);
      btn.textContent = '×';
      li.appendChild(name);
      li.appendChild(track);
      li.appendChild(btn);
      list.appendChild(li);

      var item = { li: li, bar: bar, pathname: 'reviews/' + randomId() + '.' + TYPES[type], field: null };
      items.push(item);
      btn.addEventListener('click', function () { remove(item); });
      busy += 1;
      sync();

      fetch(api + '/api/review-media-token', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ pathname: item.pathname, contentType: type })
      })
        .then(function (r) {
          if (!r.ok) return r.text().then(function (t) { throw new Error(t || 'Upload is not available right now.'); });
          return r.json();
        })
        .then(function (grant) { return put(item, file, type, grant); })
        .then(function () {
          var hidden = document.createElement('input');
          hidden.type = 'hidden';
          hidden.value = api + '/api/review-media?p=' + item.pathname;
          item.field = hidden;
          fields.appendChild(hidden);
          renumber();
          li.classList.add('rf-media__item--done');
          bar.style.width = '100%';
        })
        .catch(function (err) {
          say(err && err.message ? err.message : 'Upload failed. Please try again.');
          remove(item);
        })
        .then(function () { busy -= 1; sync(); });
    }

    input.addEventListener('change', function () {
      say('');
      Array.prototype.slice.call(input.files || []).forEach(add);
      input.value = '';
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        if (busy > 0) { e.preventDefault(); say('Please wait until your files have finished uploading.'); }
      });
    }
    sync();
  }

  function initAll() {
    document.querySelectorAll('[data-rf-media]').forEach(function (root) {
      if (root.getAttribute('data-rf-media-init')) return;
      root.setAttribute('data-rf-media-init', 'true');
      init(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
})();
